import React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import { Controller, useFormContext } from 'react-hook-form';
import dayjs, { Dayjs } from 'dayjs';
import { colors } from 'common/constants';
import { ReactComponent as CalendarIcon } from 'assets/images/icons/calendar.svg';

interface ExtendedDatePickerProps
    extends Omit<DatePickerProps<Dayjs>, 'onChange' | 'value'> {
    name: string;
    size?: 'small' | 'medium';
    placeholder?: string;
    onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
}

const BaseDatePicker: React.FC<ExtendedDatePickerProps> = ({
    name,
    ...rest
}) => {
    const { control } = useFormContext();
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Controller
                name={name}
                control={control}
                render={({ field, fieldState }) => (
                    <>
                        <DatePicker
                            {...field}
                            value={field.value ? dayjs(field.value) : null}
                            onChange={field.onChange}
                            slots={{
                                openPickerIcon: CalendarIcon,
                            }}
                            format="DD-MM-YYYY"
                            slotProps={{
                                actionBar: {
                                    actions: ['today', 'accept'],
                                },
                                textField: {
                                    error: !!fieldState.error,
                                    helperText: fieldState.error
                                        ? fieldState.error.message
                                        : null,
                                    fullWidth: true,
                                    size: rest.size || 'medium',
                                    placeholder: rest.placeholder || '',
                                    FormHelperTextProps: {
                                        sx: {
                                            ml: 0,
                                            fontSize: '14px',
                                            color: `${colors.textError} !important`,
                                            fontWeight: '400',
                                        },
                                    },
                                    onKeyDown: rest.onKeyDown,
                                },
                            }}
                            {...rest}
                        />
                    </>
                )}
            />
        </LocalizationProvider>
    );
};

export default BaseDatePicker;
